import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';

import Whychooseimg03 from '../../assets/images/blog2.png';

const Whychoosetwo = () => {
    useEffect(() => {
        const handleScroll = () => {
            const elements = document.querySelectorAll(
                '.why-choose-two-image'
            );

            elements.forEach((el) => {
                const elementTop = el.getBoundingClientRect().top;
                const elementBottom = el.getBoundingClientRect().bottom;
                const viewportTop = 0;
                const viewportBottom = window.innerHeight;

                if (elementBottom > viewportTop && elementTop < viewportBottom) {
                    el.classList.add('active');
                }
            });
        };


        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    });
   
    return (
        <div className="why-choose-two" >
            
            <div className="container">
                <div className="row gutter-y-30">
                    <div className="col-lg-7 align-self-center">
                        <div className="why-choose-right-two">
                            <div className="heading-box heading-white">
                               
                                
                                <h2 className="heading-title wow fadeInUp animated animated text-black" style={{marginTop: '0px', paddingTop: "0px", }}>
                                Our Mission
                                </h2>
                                <p style={{marginBottom: "10px"}}>To simplify legal, property, and documentation matters for NRIs by delivering reliable, transparent, and culturally aligned solutions—without requiring physical presence.</p>
                            </div>
                            <h3 className='mb-2'>We aim to:</h3>
                           <ul className='features-one-list1  mission-list ' >
                           <li style={{paddingLeft: 0}}>Eliminate complexity, confusion, and dishonesty.</li>
                        <li style={{paddingLeft: 0}}>Provide complete legal clarity and peace of mind.</li>
                        
                        <li style={{paddingLeft: 0}}>Act as your on-ground family, ensuring nothing is left to chance.</li>
                      
                           </ul>
                           
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="why-choose-two-image">
                            <img
                                src={Whychooseimg03} alt="why-choose-image"
                            />
                            <div className="image-shape">
                                <span />
                                <span />
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-12 mt-5">
                        <div className="row gutter-y-30">
                            {whychoosedata.map((data, index) =>
                                <div key={index}
                                    className="col-lg-4" >
                                    <div className="why-choose-two-box">
                                        <i className="flaticon-transparency" />
                                        <div className="why-choose-two-box-info">
                                            <h4>{data.heading}</h4>
                                            <p>
                                                {data.about}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div> */}
                </div>
            </div>
        </div >


    )
}
export default Whychoosetwo;